import { render, staticRenderFns } from "./ReferralPromotionCreateAndUpdateFormItems.vue?vue&type=template&id=6486d422&"
import script from "./ReferralPromotionCreateAndUpdateFormItems.vue?vue&type=script&lang=js&"
export * from "./ReferralPromotionCreateAndUpdateFormItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports